import { hasNonDigitCharacters } from '../helpers/index.js';
var validKpp = function validKpp(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный КПП' : _c,
    _d = _b.invalidCharactersMessage,
    invalidCharactersMessage = _d === void 0 ? 'КПП может соcтоять только из цифр' : _d,
    _e = _b.invalidLengthMessage,
    invalidLengthMessage = _e === void 0 ? 'КПП состоит из 9 цифр' : _e;
  return function (value) {
    if (!value || !value.trim()) {
      return message;
    }
    if (hasNonDigitCharacters(value)) {
      return invalidCharactersMessage;
    }
    if (value.length !== 9) {
      return invalidLengthMessage;
    }
    if (value.slice(4, 6) === '00') {
      return message;
    }
    return;
  };
};
export { validKpp };